import React from "react";
import { Route, Routes } from "react-router-dom";
import { LogIn } from "./pages/LogIn";
import { Admin } from "./pages/Admin";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { ClinqUs } from "./pages/ClinqUs";
import { Products } from "./pages/Products";
import { Resources } from "./pages/Resources";
const App = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy_policy" element={<PrivacyPolicy />} />
                <Route path="/clinq_us" element={<ClinqUs />} />
                <Route path="/product" element={<Products />} />
                <Route path="/products" element={<Products />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/login" element={<LogIn />} />
                <Route path="/clinics/*" element={<Admin />} />
                <Route path="/admin/*" element={<Admin />} />
            </Routes>
        </>
    )

};

export default App;
